import { RootState } from "../../redux/configureStore";
import { Selector, createSelector } from "@reduxjs/toolkit";
import { parseISO } from "date-fns";

const uiSliceSelector = (state: RootState) => state.ui;

export const getRightMenuIsOpen = createSelector(
  uiSliceSelector,
  (ui) => ui.rightMenuIsOpen,
);

export const getScheduleDate = createSelector(uiSliceSelector, (ui) =>
  parseISO(ui.scheduleDate),
);

export const getAudioSources = createSelector(
  uiSliceSelector,
  (ui) => ui.audioSources,
);

export const getVideoSources = createSelector(
  uiSliceSelector,
  (ui) => ui.videoSources,
);

export const getSelectedAudioSource = createSelector(
  uiSliceSelector,
  (ui) => ui.selectedAudioSource,
);

export const getSelectedVideoSource = createSelector(
  uiSliceSelector,
  (ui) => ui.selectedVideoSource,
);

export const getAlerts = createSelector(uiSliceSelector, (ui) => ui.alerts);

export function getAlert(uuid: string | undefined) {
  return createSelector(getAlerts, (alerts) => {
    if (!uuid) {
      return undefined;
    }

    return alerts.find((alert) => alert.uuid === uuid);
  });
}

export const getConfirmations = createSelector(
  uiSliceSelector,
  (ui) => ui.confirmations,
);

export const getIncompleteConfirmations = createSelector(
  getConfirmations,
  (confirmations) =>
    confirmations.filter(
      (confirmation) => confirmation.userAccepted === undefined,
    ),
);

export function getConfirmation(uuid: string | undefined) {
  return createSelector(getConfirmations, (confirmations) => {
    if (!uuid) {
      return undefined;
    }
    return confirmations.find((confirmation) => confirmation.uuid === uuid);
  });
}

export function getConfirmationResult(
  uuid: string | undefined,
): Selector<RootState, boolean | undefined> {
  return createSelector(
    getConfirmation(uuid),
    (confirmation) => confirmation?.userAccepted,
  );
}
